import {
  ACCREDITATIONS_PATH,
  ACADEMIC_PROGRAM_PATH,
  CAMPUS_PATH,
  AFFILIATION_PATH,
  AWARD_PATH,
  INSTITUTION_EVENTS_PATH,
  FACILITY_PATH,
  FACULTY_PATH,
  MILESTONE_PATH,
  NOTABLE_ALUMNUS_PATH,
  PARTNER_PATH,
  PUBLICATION_PATH,
  RESEARCH_CENTRE_PATH,
  SPECIALISATION_PATH,
  STUDENT_STATISTICS_PATH,
  TECHNOLOGY_INITIATIVE_PATH,
  STAFF_PATH,
  INSTITUTION_PROFILE_PATH,
  PUBLICATION_TYPE_PATH,
  INSTITUTION_FOCUS_AREA_PATH,
  INDUSTRY_COLLABORATION_PATH,
  STAFF_STATISTICS_PATH,
  INSTITUTION_ADMIN_DASHBOARD_PATH,
  INSTITUTION_ADMIN_PROFILE_PATH,
  GRAD_STATISTICS_PATH,
} from "./InstitutionRoutes";
import Partner from "../../views/Admin/Partners";
import StudentStatistics from "../../views/Admin/StudentStatistics";
import ResearchCentre from "../../views/Admin/ResearchCentre";
import Campus from "../../views/Admin/Campus";
import Accreditations from "../../views/Admin/Accreditations";
import Facility from "../../views/Admin/Facilities";
import Award from "../../views/Admin/Award";
import Milestone from "../../views/Admin/Milestone";
import Faculty from "../../views/Admin/Faculty";
import TechnologyInitiative from "../../views/Admin/TechnologyInitiative";
import NotableAlumnus from "../../views/Admin/NotableAlumnus";
import Event from "../../views/Admin/Event";
import Affiliation from "../../views/Admin/Affiliations";
import Specialisation from "../../views/Admin/Specialisation";
import Publication from "../../views/Admin/Publication";
import AcademicProgram from "../../views/Admin/AcademicProgram";

import Staff from "../../views/Admin/Staff";
import InstitutionProfile from "../../views/Admin/InstitutionProfile";
import PublicationType from "../../views/Admin/PublicationType";
import FocusArea from "../../views/Admin/FocusArea";

import IndustryCollaboration from "../../views/Admin/IndustryCollaboration";

import StaffStatistics from "../../views/Admin/StaffStatistics";
import Profile from "../../views/Admin/Profile";
import InstitutionAdminDashboard from "../../views/Admin/InstitutionAdminDashboard";
import GraduationStatistics from "../../views/Admin/GraduationStatistics";

export const InstitutionRouter = [
  {
    path: INSTITUTION_ADMIN_DASHBOARD_PATH,
    element: <InstitutionAdminDashboard />,
  },
  {
    path: PARTNER_PATH,
    element: <Partner />,
  },

  {
    path: STUDENT_STATISTICS_PATH,
    element: <StudentStatistics />,
  },

  {
    path: RESEARCH_CENTRE_PATH,
    element: <ResearchCentre />,
  },

  {
    path: CAMPUS_PATH,
    element: <Campus />,
  },

  {
    path: ACCREDITATIONS_PATH,
    element: <Accreditations />,
  },

  {
    path: FACILITY_PATH,
    element: <Facility />,
  },

  {
    path: AWARD_PATH,
    element: <Award />,
  },

  {
    path: MILESTONE_PATH,
    element: <Milestone />,
  },

  {
    path: FACULTY_PATH,
    element: <Faculty />,
  },

  {
    path: TECHNOLOGY_INITIATIVE_PATH,
    element: <TechnologyInitiative />,
  },

  {
    path: NOTABLE_ALUMNUS_PATH,
    element: <NotableAlumnus />,
  },

  {
    path: INSTITUTION_EVENTS_PATH,
    element: <Event />,
  },

  {
    path: AFFILIATION_PATH,
    element: <Affiliation />,
  },

  {
    path: ACADEMIC_PROGRAM_PATH,
    element: <AcademicProgram />,
  },

  {
    path: PUBLICATION_PATH,
    element: <Publication />,
  },

  {
    path: SPECIALISATION_PATH,
    element: <Specialisation />,
  },

  {
    path: STAFF_PATH,
    element: <Staff />,
  },

  {
    path: INSTITUTION_PROFILE_PATH,
    element: <InstitutionProfile />,
  },

  {
    path: PUBLICATION_TYPE_PATH,
    element: <PublicationType />,
  },

  {
    path: INSTITUTION_FOCUS_AREA_PATH,
    element: <FocusArea />,
  },

  {
    path: INDUSTRY_COLLABORATION_PATH,
    element: <IndustryCollaboration />,
  },

  {
    path: STAFF_STATISTICS_PATH,
    element: <StaffStatistics />,
  },

  {
    path: GRAD_STATISTICS_PATH,
    element: <GraduationStatistics />,
  },

  {
    path: INSTITUTION_ADMIN_PROFILE_PATH,
    element: <Profile />,
  },

  {
    path: INSTITUTION_ADMIN_DASHBOARD_PATH,
    element: <InstitutionAdminDashboard />,
  },
];
